module.exports = __webpack_public_path__ + "img/report-2.70e9088d.png";